// extracted by mini-css-extract-plugin
export default {"pages":"PageLinks-module--pages--df6cf","page":"PageLinks-module--page--127c8"};